import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealSwot";

export function selectByDealId(dealId) {
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export default {
  selectByDealId,
  insert
}